import type {ExpandableAdConfig} from 'types';

// TODO: Replace to the adoppler module
export const defaultExpandableAdConfig: ExpandableAdConfig = {
  INITIAL_WAITING_TIME_TO_EXPAND: 2000,
  FULL_SCREEN_AD_DURATION: 3000,
  DEFAULT_EXPAND_ANIMATION_DURATION: 700,
};
